import type { Step } from "react-joyride";

export const auditIssueListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການບັນຫາການກວດສອບ! ຫນ້ານີ້ຈະສະແດງລາຍການບັນຫາການກວດສອບທັງໝົດ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="issue-filter"]',
    content:
      "ນີ້ແມ່ນຕົວກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາ, ກອງຕາມລະດັບຄວາມຮຸນແຮງ, ສະຖານະ, ຫຼືພະແນກ ເພື່ອຊອກຫາບັນຫາທີ່ຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="issue-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງບັນຫາທີ່ພົບ. ທ່ານຈະເຫັນລາຍການບັນຫາການກວດສອບທັງໝົດ. ກົດທີ່ແຖວເພື່ອເບິ່ງລາຍລະອຽດ, ຫຼືໃຊ້ປຸ່ມການກະທຳເພື່ອແກ້ໄຂຫຼືລຶບ.",
    placement: "top",
  },
];

